import { render, staticRenderFns } from "./management-gdpr-roadmap-view.vue?vue&type=template&id=d00ff122"
import script from "./management-gdpr-roadmap-view.vue?vue&type=script&lang=js"
export * from "./management-gdpr-roadmap-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports